import { render } from "./mobileDefault.vue?vue&type=template&id=09006672&scoped=true"
import script from "./mobileDefault.vue?vue&type=script&lang=js"
export * from "./mobileDefault.vue?vue&type=script&lang=js"

import "./mobileDefault.vue?vue&type=style&index=0&id=09006672&scoped=true&lang=css"

import exportComponent from "/home/web/vina_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09006672"]])

export default __exports__